import { z } from 'zod';

export const schemaCompleteRegisterProduct = z.object({
  origemProduto: z.string().nonempty('Campo obrigatório'),
  pesoBruto: z.string().nonempty('Campo obrigatório'),

  altura: z.string().nonempty('Campo obrigatório'),

  largura: z.string().nonempty('Campo obrigatório'),

  profundidade: z.string().nonempty('Campo obrigatório'),

  outrosCustos: z
    .string()
    .nonempty('Campo obrigatório')
    .transform((value) => {
      const formattedValue = value.replace('R$ ', '').replace(',', '.');
      return String(formattedValue);
    }),

  minQtdSite: z.string().nonempty('Campo obrigatório'),
  maxBatidas: z.string().nonempty('Campo obrigatório'),

  minPrazoEntrega: z.string().nonempty('Campo obrigatório'),

  multiploProduto: z.string().optional(),

  ativoSite: z.string().nonempty('Campo obrigatório'),
  ativo: z.string().nonempty('Campo obrigatório')
});
